export enum DefaultDashboardDropdownValues {
  AllCases = 'allCases',
  WeightedAverage = 'weightedAverage',
}
